import React, { useState } from "react";
import axios from "axios";
import { Formik, Form, Field } from "formik";
import { Button, Typography, Input, Spin, message } from "antd";
import { API_BASE_URL } from "../config/apiConfig";
import { useTranslation } from "react-i18next";
import HomeButton from "../components/HomeButton";

const { Title } = Typography;

const VideoClip: React.FC = () => {
  const [videos, setVideos] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = async (values: { inputText: string }) => {
    setLoading(true);
    setVideos([]);

    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${API_BASE_URL}/zhadiger/api/video-clip`,
        { inputText: values.inputText },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          responseType: "json",
        }
      );

      // console.log("Video response data:", response.data);

      if (!response.data || response.data.length === 0) {
        message.warning("No videos were returned.");
        return;
      }

      const videoUrls = response.data.map(
        (base64String: string) => `data:video/mp4;base64,${base64String}`
      );

      setVideos(videoUrls);
      message.success("Videos generated successfully!");
    } catch (error) {
      message.error("Failed to generate videos.");
      console.error("Error fetching videos:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="flex justify-between items-center mb-4 ml-4 pt-4 ">
        <HomeButton />
      </div>
      <div className="max-w-[70%] mx-auto mt-10 p-6 bg-white border border-gray-200 rounded-lg shadow-md">
        <Title level={2} className="text-center font-bold text-gray-700">
          VideoClip
        </Title>

        <Formik initialValues={{ inputText: "" }} onSubmit={handleSubmit}>
          {({ isSubmitting }) => (
            <Form className="mt-6">
              <div className="mb-4">
                <Field
                  name="inputText"
                  as={Input.TextArea}
                  placeholder={t("enter_the_text")}
                  rows={4}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="flex justify-center">
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading || isSubmitting}
                  className="w-80%"
                >
                  {loading ? "Generating..." : t("generate_videos")}
                </Button>
              </div>
            </Form>
          )}
        </Formik>

        <div className="mt-6">
          {loading ? (
            <div className="text-center">
              <Spin size="large" />
            </div>
          ) : videos.length > 0 ? (
            <div>
              <Title level={4} className="text-gray-600">
                {t("generated_videos")}:
              </Title>
              <div className="flex flex-wrap justify-center gap-4 mt-4">
                {videos.map((videoUrl, index) => (
                  <video
                    key={index}
                    controls
                    src={videoUrl}
                    width={400}
                    height={300}
                    style={{ objectFit: "cover" }}
                  />
                ))}
              </div>
            </div>
          ) : (
            <p className="text-center text-gray-500">{t("no_videos")} </p>
          )}
        </div>
      </div>
    </>
  );
};

export default VideoClip;
